import { IConstraintTemplate } from '@/interfaces/portfolioOptimization.interface'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material'

import React from 'react'

interface LoadConstraintsDialogProps {
  loadTemplateModal: boolean
  setLoadTemplateModal: (open: boolean) => void
  constraintTemplates: IConstraintTemplate[]
  loadSelectedTemplate: (templateId: string) => void
  selectedConstraintTemplateId: string | null
  setSelectedConstraintTemplateId: (id: string | null) => void
}

export const LoadConstraintsDialog: React.FC<LoadConstraintsDialogProps> = ({
  loadTemplateModal,
  setLoadTemplateModal,
  constraintTemplates,
  loadSelectedTemplate,
  selectedConstraintTemplateId,
  setSelectedConstraintTemplateId,
}) => {
  return (
    <Dialog
      open={loadTemplateModal}
      onClose={() => setLoadTemplateModal(false)}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle>Load Constraint Template</DialogTitle>
      <Divider />
      <DialogContent>
        <FormControl variant='standard' fullWidth>
          <Select
            placeholder='Search constraint to load'
            labelId='load-screen-constraint-modal-label'
            id='load-screen-constraint-modal'
            value={selectedConstraintTemplateId || ''}
            onChange={(event: SelectChangeEvent<string>) => {
              setSelectedConstraintTemplateId(event.target.value)
            }}
          >
            {constraintTemplates?.length ? (
              constraintTemplates?.map((template) => (
                <MenuItem key={template.id} value={template.id}>
                  {template.description}
                </MenuItem>
              ))
            ) : (
              <MenuItem value=''>
                <em>No constraint template available</em>
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant='contained'
          disabled={!selectedConstraintTemplateId}
          size='small'
          onClick={() =>
            loadSelectedTemplate(selectedConstraintTemplateId || '')
          }
        >
          Load
        </Button>
        <Button
          variant='outlined'
          onClick={() => setLoadTemplateModal(false)}
          size='small'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
